import { AppShell } from '@/components/layout/AppShell';
import { AuthProvider, useMeQuery } from '@/lib/auth';
import LoginPage from '@/pages/LoginPage';

export function AuthGate() {
  const me = useMeQuery();
  if (me.isPending) {
    return (
      <div className="flex h-screen items-center justify-center text-muted-foreground" aria-busy="true">
        Loading…
      </div>
    );
  }
  if (me.isError) {
    return (
      <div role="alert" className="flex h-screen items-center justify-center text-destructive">
        Could not reach Taim. Please refresh.
      </div>
    );
  }
  if (!me.data) return <LoginPage />;
  return (
    <AuthProvider me={me.data}>
      <AppShell />
    </AuthProvider>
  );
}
